import { TableOfContentsItem } from '@modules/editor/extensions/tableOfContents';
import { Editor } from '@tiptap/react';
import { createContext, useContext, useMemo } from 'react';
import { Doc } from 'src/@types/docs';
import { useDocContentEditor } from './useDocContentEditor';

type State = {
  doc: Doc;
  editor: Editor;
  tableOfContents: TableOfContentsItem[];
  canRender: boolean;
};

const context = createContext<State | undefined>(undefined);

export const useDocContentContext = () => {
  const state = useContext(context);
  if (!state) {
    throw new Error(
      'useDocContentEditor must be used within a DocContentEditorProvider',
    );
  }
  return state;
};

export const DocContentContextProvider = ({
  doc,
  children,
}: React.PropsWithChildren<{ doc: Doc }>) => {
  const { editor, tableOfContents, canRender } = useDocContentEditor(doc);

  const value = useMemo(
    () => ({
      doc,
      editor,
      tableOfContents,
      canRender,
    }),
    [doc, editor, tableOfContents, canRender],
  );

  return <context.Provider value={value}>{children}</context.Provider>;
};
